import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {
  FormField,
  FormFieldError,
  FormFieldHelperText,
} from "../../../../../../../design-system/form-field";
import {CreateKycBasicFormStepFormValues} from "../../schema-validation";

export function KycLegalNameFormField() {
  const {control} = useFormContext<CreateKycBasicFormStepFormValues>();

  return (
    <FormField
      id="legalName"
      label="Full legal name"
      renderInput={(id) => (
        <Controller
          control={control}
          name="legalName"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Space size={4} direction="vertical" style={{display: "flex"}}>
                <Input
                  id={id}
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value === null ? undefined : value}
                  placeholder="e.g., Jane Doe"
                  ref={ref}
                />
                <FormFieldHelperText text="Exactly as it appears on your government issued ID documents" />
              </Space>
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
